import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageColumnsModule } from 'src/app/common/image-columns/image-columns.module';
import { EastAsiaComponent } from './east-asia.component';

@NgModule({
  declarations: [
    EastAsiaComponent
  ],
  imports: [
    CommonModule,
    ImageColumnsModule
  ],
  exports: [
    EastAsiaComponent
  ]
})
export class EastAsiaModule { }
